import { render, staticRenderFns } from "./EditableOrder.vue?vue&type=template&id=34c712fe&scoped=true&"
import script from "./EditableOrder.vue?vue&type=script&lang=js&"
export * from "./EditableOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditableOrder.vue?vue&type=style&index=0&id=34c712fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c712fe",
  null
  
)

export default component.exports